// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-b1be060c] {\n  margin-bottom: 0.5rem;\n  font-size: 15px;\n  font-weight: 600;\n}\n", ""]);
// Exports
module.exports = exports;
